(function () {
  if (window.wholesaleApplicationFormLoaded) {
    return;
  }

  window.wholesaleApplicationFormLoaded = true;

  function normalizeContactName(name) {
    return name.replace(/^contact\[/, "").replace(/\]$/, "");
  }

  var ERROR_MESSAGES = {
    "Missing shop":
      "We couldn't identify the shop for this request. Please refresh the page and try again.",
    Unauthorized:
      "We couldn't verify this shop session. Please refresh the page and try again.",
    "A wholesale request already exists for this email":
      "A wholesale request already exists for this email.",
    "Unable to fetch Shopify customer":
      "We couldn't verify your customer record right now. Please try again in a few minutes.",
    "Unable to save wholesale request":
      "We couldn't save your wholesale request right now. Please try again.",
  };

  function setWholesaleMessage(messageElement, message, type, shouldFocus) {
    if (!messageElement) {
      return;
    }

    messageElement.textContent = message;
    messageElement.hidden = false;
    messageElement.classList.toggle("errors", type === "error");
    messageElement.classList.toggle("form-success", type === "success");
    messageElement.classList.toggle(
      "wholesale-application__message--loading",
      type === "loading",
    );
    messageElement.setAttribute("role", type === "error" ? "alert" : "status");
    messageElement.setAttribute(
      "aria-live",
      type === "error" ? "assertive" : "polite",
    );

    if (shouldFocus) {
      messageElement.focus();
    }
  }

  function formatErrorDetails(details) {
    if (!details) {
      return "";
    }

    if (typeof details === "string") {
      return details;
    }

    if (Array.isArray(details)) {
      return details.join(" ");
    }

    return JSON.stringify(details);
  }

  function buildWholesaleErrorMessage(response, data, form) {
    var fallbackMessage = form.dataset.errorMessage;
    var responseError = data && data.error;
    var statusMessages = {
      400: responseError === "Missing shop"
        ? ERROR_MESSAGES["Missing shop"]
        : responseError || "Please check the form and try again.",
      401: ERROR_MESSAGES.Unauthorized,
      409: ERROR_MESSAGES["A wholesale request already exists for this email"],
      502: ERROR_MESSAGES["Unable to fetch Shopify customer"],
      500: ERROR_MESSAGES["Unable to save wholesale request"],
    };
    var errorMessage =
      ERROR_MESSAGES[responseError] ||
      statusMessages[response.status] ||
      responseError ||
      fallbackMessage;
    var errorDetails = formatErrorDetails(data && data.details);

    if (errorDetails && response.status === 400) {
      errorMessage += " " + errorDetails;
    }

    return errorMessage;
  }

  document.addEventListener("submit", function (event) {
    var form = event.target.closest("[data-wholesale-application-form]");

    if (!form) {
      return;
    }

    event.preventDefault();

    var endpointUrl = form.dataset.endpointUrl;
    var messageElement = form.querySelector("[data-wholesale-message]");
    var button = form.querySelector("[data-wholesale-submit-button]");
    var originalButtonText = button ? button.textContent : "";

    if (!endpointUrl) {
      setWholesaleMessage(
        messageElement,
        form.dataset.errorMessage,
        "error",
        true,
      );
      return;
    }

    if (!form.reportValidity()) {
      return;
    }

    var formData = new FormData(form);
    var payload = {
      shop_domain: form.dataset.shopDomain,
    };

    formData.forEach(function (value, key) {
      if (key === "form_type" || key === "utf8") {
        return;
      }

      payload[normalizeContactName(key)] = value;
    });

    var requestUrl = new URL(endpointUrl, window.location.origin);

    if (form.dataset.shopDomain) {
      requestUrl.searchParams.set("shop", form.dataset.shopDomain);
    }

    if (button) {
      button.disabled = true;
      button.textContent = form.dataset.submittingText;
    }

    form.setAttribute("aria-busy", "true");
    setWholesaleMessage(
      messageElement,
      form.dataset.loadingMessage ||
        form.dataset.submittingText ||
        "Submitting your wholesale request...",
      "loading",
      false,
    );

    fetch(requestUrl.toString(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            if (!response.ok || data.ok === false) {
              throw new Error(buildWholesaleErrorMessage(response, data, form));
            }

            return data;
          });
      })
      .then(function (data) {
        form.reset();
        setWholesaleMessage(
          messageElement,
          data.message || form.dataset.successMessage,
          "success",
          true,
        );
      })
      .catch(function (error) {
        setWholesaleMessage(
          messageElement,
          error.message || form.dataset.errorMessage,
          "error",
          true,
        );
      })
      .finally(function () {
        form.removeAttribute("aria-busy");

        if (button) {
          button.disabled = false;
          button.textContent = originalButtonText;
        }
      });
  });
})();
